// extracted by mini-css-extract-plugin
export default {"checkbox":"checkbox-at0b1","checkbox__mobile":"checkbox__mobile-EZK8b","checkboxMobile":"checkbox__mobile-EZK8b"};